module.exports = __webpack_public_path__ + "img/bg-water.8db64485.png";